/* ============================================================
   Ecrilo — landing pages A/B · script partagé
   Trois rôles, aucune dépendance :
     1. pont de tracking : chaque interaction du playbook est publiée sur
        le bus analytics de Shopify, où notre Web Pixel (Fluviqa Tracking)
        la reçoit et la transmet à /track ;
     2. révélation au défilement et animation du motif ;
     3. CTA collant mobile, vidéo « clic pour lire », galerie, FAQ.
   ============================================================ */
(function () {
  "use strict";

  var doc = document;
  doc.documentElement.classList.add("ec-js");
  // Mémorise la fiche en cours : les pages légales y ramènent le lecteur.
  try { sessionStorage.setItem("ec_lp_retour", location.pathname + location.search); } catch (e) {}   // les révélations ne masquent rien sans JavaScript
  var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ── Variante de la page ────────────────────────────────── */
  var root = doc.querySelector("[data-ec-variant]");
  var VARIANT = (root && root.getAttribute("data-ec-variant")) || "A";

  /* ── Offre en cours ──────────────────────────────────────────
     Le sélecteur de paliers et le bouton d'achat sont dans deux endroits
     différents du script. Ils partagent donc ici ce que vaut, à cet instant,
     ce que le visiteur s'apprête à acheter — sans quoi le clic d'achat
     partirait sans montant. Les centimes sont la seule unité employée. */
  var socleOffre = doc.querySelector("[data-ec-paliers], [data-ec-quantite]");
  var OFFRE = {
    produit: socleOffre ? socleOffre.getAttribute("data-ec-produit") || "" : "",
    devise: socleOffre ? socleOffre.getAttribute("data-ec-devise") || "" : "",
    unitaire: socleOffre ? parseInt(socleOffre.getAttribute("data-ec-unitaire-cents"), 10) || 0 : 0
  };
  var etatOffre = { qte: 1, cle: null, totalCents: 0 };

  function donneesOffre() {
    var cents = etatOffre.totalCents || OFFRE.unitaire * etatOffre.qte;
    return {
      produit: OFFRE.produit || undefined,
      devise: OFFRE.devise || undefined,
      valeur: cents ? Math.round(cents) / 100 : undefined,
      quantite: etatOffre.qte
    };
  }

  /* ── Pont de tracking ───────────────────────────────────────
     Le catalogue serveur de Fluviqa Tracking refuse tout événement
     inconnu (400 not_in_catalog). Les quinze événements du playbook sont
     donc PROJETÉS sur le vocabulaire existant — `catalog` ci-dessous —
     et leur nom d'origine voyage dans `action`. Le Web Pixel ne
     transmet que les noms de cette liste.
  */
  var PLAN = {
    component_view:     { catalog: "fg_section_view" },
    method_step_view:   { catalog: "fg_section_view" },
    hero_cta_click:     { catalog: "cta_click" },
    buy_cta_click:      { catalog: "cta_click" },
    trust_item_click:   { catalog: "cta_click" },
    gallery_interaction:{ catalog: "media_interaction" },
    video_start:        { catalog: "media_interaction" },
    video_progress_50:  { catalog: "media_interaction" },
    review_interaction: { catalog: "media_interaction" },
    offer_view:         { catalog: "view_promotion" },
    /* Le tunnel, dans l'ordre où il se vit :
       vue → engagement qualifié → choix d'offre → intention d'achat.
       `purchase` n'est pas ici : il vient du webhook orders/paid. */
    landing_view_item:  { catalog: "view_item" },
    engagement_qualifie:{ catalog: "engagement" },
    pack_select:        { catalog: "select_item" },
    pack_panier:        { catalog: "add_to_cart" },
    scroll_75:          { catalog: "scroll_depth_75" }
  };

  var seen = {};
  function track(action, data) {
    var spec = PLAN[action];
    if (!spec) return;
    var payload = {
      ecrilo: true,
      catalog: spec.catalog,
      action: action,
      variant: VARIANT,
      component_id: (data && data.component_id) || null,
      cta_id: (data && data.cta_id) || null,
      params: (data && data.params) || {}
    };
    /* Un choix d'offre, une mise au panier ou une intention d'achat sans
       produit ni montant est un signal que la régie ne peut pas optimiser :
       on joint l'identité marchande dès qu'on la connaît. */
    if (data && data.produit) payload.shopify_product_id = data.produit;
    if (data && data.valeur != null) payload.value = data.valeur;
    if (data && data.devise) payload.currency = data.devise;
    if (data && data.quantite != null) payload.quantity = data.quantite;
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
        var p = window.Shopify.analytics.publish("ecrilo:" + action, payload);
        if (p && typeof p.catch === "function") p.catch(function () {});
      }
      doc.dispatchEvent(new CustomEvent("ecrilo:track", { detail: payload }));
    } catch (e) { /* jamais bloquant pour la page */ }
  }
  function once(key, fn) { if (seen[key]) return; seen[key] = true; fn(); }

  /* ── Qualification de l'engagement ───────────────────────────
     « Engagement » ne veut rien dire s'il se déclenche au premier clic venu :
     une régie qui reçoit un signal à chaque ouverture de FAQ optimise vers des
     gens qui ouvrent des FAQ. On le réserve donc à un visiteur RÉELLEMENT
     engagé, et il ne part qu'UNE FOIS par session.

     Trois critères, un seul suffit :
       a. 30 secondes de présence ACTIVE (le compteur s'arrête quand l'onglet
          passe en arrière-plan — sinon un onglet oublié se qualifie tout seul) ;
       b. 50 % de la page parcourue ;
       c. 2 interactions volontaires parmi : ouverture de FAQ, galerie, vidéo,
          étape de méthode lue, changement de quantité, choix de palier.

     Le détail voyage dans la charge utile : les micro-interactions ne sont plus
     émises séparément, mais rien de ce qu'elles disaient n'est perdu. */
  var CRITERES = { secondes: 30, defilement: 0.5, interactions: 2 };
  var CLE_ENGAGE = "ec_engage";
  var eng = { secondes: 0, defilement: 0, signaux: [], fait: false };

  try { eng.fait = sessionStorage.getItem(CLE_ENGAGE) === "1"; } catch (e) {}

  function qualifier(raison) {
    if (eng.fait) return;
    eng.fait = true;
    try { sessionStorage.setItem(CLE_ENGAGE, "1"); } catch (e) {}
    var signal = donneesOffre();
    signal.params = {
      raison: raison,
      secondes_actives: eng.secondes,
      defilement: Math.round(eng.defilement * 100),
      signaux: eng.signaux.slice(0, 12)
    };
    track("engagement_qualifie", signal);
  }

  /* Une interaction volontaire : elle compte, elle n'émet pas. */
  function interagir(nom) {
    if (eng.fait) return;
    if (eng.signaux.indexOf(nom) === -1) eng.signaux.push(nom);
    if (eng.signaux.length >= CRITERES.interactions) qualifier("interactions");
  }

  if (!eng.fait) {
    var horloge = setInterval(function () {
      if (doc.hidden) return;
      eng.secondes += 1;
      if (eng.secondes >= CRITERES.secondes) { qualifier("duree"); clearInterval(horloge); }
    }, 1000);
  }

  /* ── Vue des composants + révélation ───────────────────────── */
  var sections = doc.querySelectorAll("[data-ec-component]");
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target, id = el.getAttribute("data-ec-component");
        el.classList.add("is-visible");
        el.querySelectorAll(".ec-reveal, .ec-reveal--stagger, .ec-motif").forEach(function (n) { n.classList.add("is-visible"); });
        once("view:" + id, function () {
          track(id === "C06" ? "offer_view" : "component_view", { component_id: id });
        });
        el.querySelectorAll("[data-ec-step]").forEach(function (s) {
          once("step:" + id + ":" + s.getAttribute("data-ec-step"), function () {
            track("method_step_view", { component_id: id, params: { step: s.getAttribute("data-ec-step") } });
            interagir("method_step_view");
          });
        });
      });
    }, { threshold: 0, rootMargin: "0px 0px -8% 0px" });   // seuil 0 : une section plus haute que l'écran doit pouvoir se révéler
    sections.forEach(function (s) { io.observe(s); });
  } else {
    sections.forEach(function (s) { s.classList.add("is-visible"); });
  }

  /* ── Clics sur les CTA ──────────────────────────────────────── */
  doc.addEventListener("click", function (ev) {
    var cta = ev.target.closest && ev.target.closest("[data-ec-cta]");
    if (!cta) return;
    var section = cta.closest("[data-ec-component]");
    var ctaId = cta.getAttribute("data-ec-cta");
    var action = ctaId === "hero_cta" ? "hero_cta_click"
               : ctaId.indexOf("trust_") === 0 ? "trust_item_click"
               : "buy_cta_click";
    track(action, {
      component_id: section ? section.getAttribute("data-ec-component") : null,
      cta_id: ctaId,
      params: { cta_copy: (cta.textContent || "").trim().slice(0, 80) }
    });
    var href = cta.getAttribute("href") || "";
    var versAchat = href.indexOf("/cart/") === 0;

    /* ── Passage à l'achat ───────────────────────────────────────
       Un CTA dont le lien mène à `/cart/…` EST le pas « passer à l'achat » : la
       fiche ne passe pas par le panier, ce permalien file droit au checkout.

       On n'émet pourtant PLUS `begin_checkout` ici. Trois émetteurs décrivaient
       le même pas — ce clic, l'ouverture du checkout vue par le pixel, et le
       webhook `checkouts/create` — sans partager la moindre clé. Meta ne pouvait
       pas les dédupliquer, et chaque visiteur qui passait à l'achat en comptait
       deux. Le webhook est désormais seul : il ne dépend ni du consentement ni
       du bac à sable, porte un identifiant déterministe, et transporte
       l'identité complète du client.

       Le clic reste mesuré : `buy_cta_click` part en `cta_click` juste au-dessus,
       avec son `cta_id`. Rien n'est perdu côté analyse interne. */
    // Achat direct : on laisse 120 ms au pixel avant de quitter la page.
    if (cta.tagName === "A" && versAchat && !ev.metaKey && !ev.ctrlKey && !ev.shiftKey) {
      ev.preventDefault();
      setTimeout(function () { window.location.assign(href); }, 120);
    }
  });

  /* ── Galerie : vignettes illustrées ─────────────────────────────
     Les <source> du <picture> portent la DIRECTION ARTISTIQUE : sur mobile,
     un recadrage 4:5 dédié, pendant que la boîte est elle-même en 4:5.

     La version précédente les SUPPRIMAIT au premier clic (`so.remove()`).
     C'était irréversible : l'<img> n'était plus piloté que par data-srcset,
     qui pointe toujours vers le rendu 16:10 de bureau. En revenant sur la
     première vue, on affichait donc une image 16:10 dans une boîte 4:5 —
     `cover` en coupait la moitié, et le navigateur agrandissait deux fois une
     source trop étroite, d'où le flou.

     On les RÉÉCRIT au lieu de les détruire : chaque vignette peut fournir son
     propre recadrage mobile (data-srcset-mobile) ; à défaut, le <source> reçoit
     le même rendu que l'<img>, ce qui montre la bonne image plutôt qu'une
     ancienne restée en place. Revenir sur la première vue rétablit son 4:5. */
  doc.querySelectorAll("[data-ec-gallery]").forEach(function (g) {
    var main = g.querySelector("[data-ec-gallery-main]");
    var thumbs = g.querySelectorAll(".ec-gallery__thumb");
    var img = main && main.querySelector("img");
    var pic = img && img.closest("picture");
    var sources = pic ? [].slice.call(pic.querySelectorAll("source")) : [];
    var srcsetsOrigine = sources.map(function (so) { return so.getAttribute("srcset"); });

    thumbs.forEach(function (t, i) {
      t.addEventListener("click", function () {
        var src = t.getAttribute("data-src"), alt = t.getAttribute("data-alt");
        if (img && src) {
          var ssBureau = t.getAttribute("data-srcset");
          var ssMobile = t.getAttribute("data-srcset-mobile");
          sources.forEach(function (so, k) {
            var valeur = ssMobile || ssBureau || srcsetsOrigine[k];
            if (valeur) so.setAttribute("srcset", valeur);
          });
          if (ssBureau) img.srcset = ssBureau; else img.removeAttribute("srcset");
          img.src = src; img.alt = alt || "";
        }
        thumbs.forEach(function (o) { o.setAttribute("aria-pressed", o === t ? "true" : "false"); });
        var section = g.closest("[data-ec-component]");
        track("gallery_interaction", { component_id: section && section.getAttribute("data-ec-component"), params: { image_index: i } });
      });
    });
  });

  /* ── Achat : paliers, quantité, montants, liens ─────────────────
     UN SEUL ÉTAT pour toute la page. Le hero, la section Offre, la barre
     collante et le curseur de repli lisent et écrivent le même palier : deux
     états séparés finiraient par diverger, et le client partirait au checkout
     avec un choix qui n'est pas le sien.

     LES LIENS NE SONT PAS FABRIQUÉS ICI. Chaque palier porte son propre lien,
     rendu par Liquid avec sa quantité, son pack et son éventuel code de remise.
     Le script se contente de recopier celui du palier choisi sur les autres
     boutons d'achat. Rien à reconstruire, donc rien à casser. */
  var paliersGroupes = [].slice.call(doc.querySelectorAll("[data-ec-paliers]"));
  var qteRacines = [].slice.call(doc.querySelectorAll("[data-ec-quantite]"));

  if (paliersGroupes.length || qteRacines.length) {
    var refQte = qteRacines[0] || null;
    var QMAX = refQte ? parseInt(refQte.getAttribute("data-ec-max"), 10) || 10 : 10;
    var TOTAUX = refQte ? (refQte.getAttribute("data-ec-totaux") || "").split("|") : [];
    var AVANT = refQte ? (refQte.getAttribute("data-ec-totaux-avant") || "").split("|") : [];
    var UNITAIRE = refQte ? refQte.getAttribute("data-ec-unitaire") || "" : "";
    var REMISES = refQte ? (refQte.getAttribute("data-ec-remises") || "").split("|") : [];

    var qte = 1;
    var pal = null; /* le palier choisi, ou null si quantité libre */

    var annonce = doc.createElement("p");
    annonce.className = "ec-sr-only";
    annonce.setAttribute("role", "status");
    annonce.setAttribute("aria-live", "polite");
    doc.body.appendChild(annonce);

    function tousLesPaliers() {
      return [].slice.call(doc.querySelectorAll("[data-ec-pal]"));
    }
    function infos(el) {
      return {
        el: el,
        cle: el.getAttribute("data-ec-cle"),
        qte: parseInt(el.getAttribute("data-ec-qte"), 10) || 1,
        texte: el.getAttribute("data-ec-pal-texte") || "",
        avant: el.getAttribute("data-ec-pal-avant") || "",
        remise: el.getAttribute("data-ec-pal-remise") || "",
        href: el.getAttribute("data-ec-href") || null
      };
    }
    function totalTexte() {
      if (pal && pal.texte) return pal.texte;
      return TOTAUX[qte - 1] || "";
    }

    /* Un montant qui change doit se remarquer sans clignoter. */
    function ecrire(el, texte) {
      if (!el || el.textContent === texte) return;
      el.textContent = texte;
      el.classList.remove("is-maj");
      void el.offsetWidth;
      el.classList.add("is-maj");
    }

    function majMontants() {
      var t = totalTexte();
      if (t) [].slice.call(doc.querySelectorAll("[data-ec-total]")).forEach(function (e) { ecrire(e, t); });
      /* Le prix barré suit TOUJOURS le prix affiché. La version précédente ne
         le mettait à jour qu'en quantité libre : avec un palier choisi, la
         barre collante montrait « 58,00 € barré 35,00 € », ce qui ne veut rien
         dire. Le palier fournit sa propre référence ; à défaut on prend celle
         de la quantité courante. */
      var refAvant = (pal && pal.avant) ? pal.avant : AVANT[qte - 1];
      [].slice.call(doc.querySelectorAll("[data-ec-total-avant]")).forEach(function (e) {
        if (refAvant) { ecrire(e, refAvant); e.parentNode.hidden = false; }
        else if (e.parentNode) { e.parentNode.hidden = true; }
      });

      /* La remise se recalcule avec eux : figée, elle finirait par contredire
         les deux montants qu'elle prétend relier. */
      var pct = (pal && pal.remise !== "") ? pal.remise : REMISES[qte - 1];
      [].slice.call(doc.querySelectorAll("[data-ec-remise]")).forEach(function (e) {
        var n = parseInt(pct, 10);
        if (isNaN(n) || n <= 0) { e.hidden = true; return; }
        e.hidden = false;
        ecrire(e, "−" + n + " %");
      });
      [].slice.call(doc.querySelectorAll("[data-ec-detail]")).forEach(function (e) {
        var visible = qte > 1;
        e.textContent = visible ? qte + " × " + UNITAIRE : "";
        e.hidden = !visible;
      });
    }

    /* Le lien du palier choisi devient celui de tous les boutons d'achat.
       Exceptions : le lien propre à chaque palier, déjà juste, et l'ancre
       « classe », qui ne doit jamais être écrasée par le palier courant. */
    function majLiens() {
      var href = pal && pal.href ? pal.href : hrefLibre();
      if (!href) return;
      [].slice.call(doc.querySelectorAll("a[data-ec-cta]")).forEach(function (a) {
        if (a.closest("[data-ec-pal]")) return;
        if (a.getAttribute("data-ec-cta") === "classe_cta") return;
        if ((a.getAttribute("href") || "").indexOf("/cart/") === -1) return;
        a.setAttribute("href", href);
      });
    }

    /* Quantité libre : on repart du gabarit du premier palier, on remplace la
       quantité, on marque le pack « libre » et on retire tout code de remise —
       il ne vaudrait pas pour cette quantité-là. */
    function hrefLibre() {
      var premier = tousLesPaliers()[0];
      var base = premier ? premier.getAttribute("data-ec-href") : null;
      if (!base) {
        var q = doc.querySelector('a[data-ec-cta="buy_cta"]');
        base = q ? q.href : null;
      }
      if (!base || base.indexOf("/cart/") === -1) return null;
      var u = base.replace(/\/cart\/(\d+):\d+/, "/cart/$1:" + qte);
      u = u.replace(/([?&])discount=[^&]*/g, "$1").replace(/[?&]$/, "");
      if (/attributes\[ecrilo_pack\]=[^&]*/.test(u)) {
        u = u.replace(/attributes\[ecrilo_pack\]=[^&]*/, "attributes[ecrilo_pack]=libre");
      } else {
        u += (u.indexOf("?") === -1 ? "?" : "&") + "attributes[ecrilo_pack]=libre";
      }
      return u.replace(/&&+/g, "&").replace(/\?&/, "?");
    }

    function majEtatPaliers() {
      tousLesPaliers().forEach(function (el) {
        var choisi = pal ? el.getAttribute("data-ec-cle") === pal.cle : false;
        el.classList.toggle("is-choisi", choisi);
        var r = el.querySelector(".ec-pal__radio");
        if (r && r.checked !== choisi) r.checked = choisi;
      });
    }

    function majSteppers() {
      qteRacines.forEach(function (r) {
        var champ = r.querySelector("[data-ec-qte-champ]");
        if (champ && champ.value !== String(qte)) champ.value = qte;
        [].slice.call(r.querySelectorAll("[data-ec-qte]")).forEach(function (b) {
          var pas = parseInt(b.getAttribute("data-ec-qte"), 10);
          b.disabled = (pas < 0 && qte <= 1) || (pas > 0 && qte >= QMAX);
        });
      });
    }

    function appliquer(source) {
      etatOffre.qte = qte;
      etatOffre.cle = pal ? pal.cle : "libre";
      etatOffre.totalCents = pal
        ? parseInt(pal.el.getAttribute("data-ec-pal-total"), 10) || 0
        : 0;
      majEtatPaliers();
      majSteppers();
      majMontants();
      majLiens();
      if (source) {
        annonce.textContent =
          (pal ? pal.el.querySelector(".ec-pal__nom").textContent + ", " : qte + (qte > 1 ? " kits, " : " kit, ")) +
          "total " + totalTexte();
      }
    }

    /* ── Changement d'offre ──────────────────────────────────────
       Le choix d'une offre est le pivot du tunnel : c'est là que le visiteur
       cesse de regarder et commence à composer sa commande. On émet alors
       `select_item` (il a choisi) ET `add_to_cart` (son panier vaut désormais
       ceci), tous deux avec produit, montant et quantité.

       DEUX GARDE-FOUS.
       1. `source` est faux à l'initialisation : le palier conseillé est coché
          par le serveur, personne ne l'a choisi. Rien ne part au chargement.
       2. Une signature mémorise la dernière offre annoncée : repasser par le
          même palier, ou revenir à la même quantité, ne réémet rien.
       Le pas-à-pas du sélecteur de quantité est temporisé : 1 → 2 → 3 en trois
       clics est UNE décision, pas trois. */
    var derniereOffre = null;
    var minuteurOffre = null;

    function annoncerOffre(origine) {
      var signature = etatOffre.cle + ":" + etatOffre.qte;
      if (signature === derniereOffre) return;
      derniereOffre = signature;
      var d = donneesOffre();
      d.params = { pack: etatOffre.cle, quantity: etatOffre.qte, origine: origine };
      track("pack_select", d);
      track("pack_panier", d);
    }

    function annoncerOffreTemporisee(origine) {
      clearTimeout(minuteurOffre);
      minuteurOffre = setTimeout(function () { annoncerOffre(origine); }, 400);
    }

    function choisirPalier(el, source) {
      pal = infos(el);
      qte = pal.qte;
      appliquer(source);
      if (source) {
        interagir("pack_select");
        annoncerOffre("palier");
      }
    }

    function choisirQuantite(valeur, source) {
      var n = parseInt(valeur, 10);
      if (isNaN(n)) n = 1;
      qte = Math.min(QMAX, Math.max(1, n));
      /* Une quantité qui retombe pile sur un palier reprend ce palier :
         sinon deux chemins mèneraient au même panier avec deux étiquettes. */
      var correspond = tousLesPaliers().filter(function (el) {
        return parseInt(el.getAttribute("data-ec-qte"), 10) === qte;
      })[0];
      pal = correspond ? infos(correspond) : null;
      appliquer(source);
      if (source) {
        interagir("quantity_change");
        /* Changer la quantité change l'offre : même palier ou quantité libre,
           ce qui partira au panier n'est plus le même. */
        annoncerOffreTemporisee("quantite");
      }
    }

    tousLesPaliers().forEach(function (el) {
      var r = el.querySelector(".ec-pal__radio");
      if (r) r.addEventListener("change", function () { if (r.checked) choisirPalier(el, true); });
    });

    qteRacines.forEach(function (r) {
      [].slice.call(r.querySelectorAll("[data-ec-qte]")).forEach(function (b) {
        b.addEventListener("click", function () {
          choisirQuantite(qte + parseInt(b.getAttribute("data-ec-qte"), 10), true);
        });
      });
      var champ = r.querySelector("[data-ec-qte-champ]");
      if (champ) {
        champ.addEventListener("input", function () { choisirQuantite(champ.value, true); });
        champ.addEventListener("blur", function () { champ.value = qte; });
      }
    });

    /* Repli déroulant du curseur : le chemin court reste court. */
    [].slice.call(doc.querySelectorAll("[data-ec-qte-bascule]")).forEach(function (b) {
      b.addEventListener("click", function () {
        var cible = doc.getElementById(b.getAttribute("aria-controls"));
        if (!cible) return;
        var ouvert = b.getAttribute("aria-expanded") === "true";
        b.setAttribute("aria-expanded", ouvert ? "false" : "true");
        cible.hidden = ouvert;
        if (!ouvert) {
          var champ = cible.querySelector("[data-ec-qte-champ]");
          if (champ) champ.focus();
        }
      });
    });

    /* État de départ : le palier conseillé, déjà coché côté serveur. */
    var initial = tousLesPaliers().filter(function (el) {
      var r = el.querySelector(".ec-pal__radio");
      return r && r.checked;
    })[0];
    if (initial) choisirPalier(initial, false); else choisirQuantite(1, false);
    derniereOffre = etatOffre.cle + ":" + etatOffre.qte;

    /* ── Vue produit sur une page qui n'en est pas une ───────────
       La page d'accueil et les landings A/B présentent le produit, mais leur
       URL n'est pas `/products/…` : Shopify n'y émet jamais `product_viewed`,
       donc aucun `view_item` n'était collecté pour ces visiteurs — c'est-à-dire
       pour la quasi-totalité d'entre eux, puisque c'est là qu'ils arrivent.
       On l'émet donc depuis la page, et UNIQUEMENT là : sur une vraie fiche
       produit, Shopify s'en charge et un second émetteur doublerait le compte. */
    if (OFFRE.produit && location.pathname.indexOf("/products/") !== 0) {
      once("landing_view_item", function () {
        var vu = donneesOffre();
        vu.quantite = 1;
        vu.valeur = OFFRE.unitaire ? Math.round(OFFRE.unitaire) / 100 : undefined;
        vu.params = { chemin: location.pathname };
        track("landing_view_item", vu);
      });
    }
  }

  /* ── Les stories sous la fiche produit, sur mobile ──────────────
     Le rail est une section SŒUR du hero, pas un enfant de sa grille, et aucune
     propriété CSS ne déplace un élément d'un parent à l'autre. On le déplace
     donc réellement, en dessous de 1024 px, où la grille du hero est sur une
     seule colonne. Au-dessus, il retourne à sa place.

     Il se plaçait au départ ENTRE les images et la copie. Sur mobile, cela
     repoussait le titre, le prix et le bouton d'achat sous un rail de vidéos :
     on découvrait quatre bulles avant de savoir ce qui était vendu et à quel
     prix. Le rail passe donc APRÈS la copie — les images, la fiche produit,
     puis seulement les vidéos.

     Un commentaire sert de marque-page : sans lui, le retour se ferait « à la
     fin du parent », ce qui n'est pas la même chose que « là où il était ». */
  var stories = doc.querySelector("[data-ec-stories]");
  var split = doc.querySelector(".ec-split");
  var copie = split ? split.querySelector(".ec-split__copy") : null;

  if (stories && split && copie && stories.parentNode) {
    var marque = doc.createComment(" ec-stories ");
    stories.parentNode.insertBefore(marque, stories);

    var etroit = window.matchMedia("(max-width: 1023px)");

    function placerStories() {
      if (etroit.matches) {
        if (stories.parentNode !== split) split.insertBefore(stories, copie.nextSibling);
        stories.classList.add("ec-stories--dans-hero");
      } else {
        if (stories.parentNode === split) marque.parentNode.insertBefore(stories, marque);
        stories.classList.remove("ec-stories--dans-hero");
      }
    }

    placerStories();
    if (etroit.addEventListener) etroit.addEventListener("change", placerStories);
    else if (etroit.addListener) etroit.addListener(placerStories);
    /* Second signal : certains contextes ne relaient pas l evenement change de
       matchMedia. Un redimensionnement suffit alors a replacer le rail. */
    var minuteur;
    window.addEventListener("resize", function () {
      clearTimeout(minuteur);
      minuteur = setTimeout(placerStories, 150);
    });
  }

  /* ── Vidéo : clic pour lire, jamais de son automatique ──────── */
  doc.querySelectorAll("[data-ec-video]").forEach(function (wrap) {
    var video = wrap.querySelector("video"), btn = wrap.querySelector(".ec-video__play");
    var iframe = wrap.querySelector("iframe");
    var section = wrap.closest("[data-ec-component]");
    var cid = section && section.getAttribute("data-ec-component");
    var vid = wrap.getAttribute("data-ec-video") || "demo";
    if (btn) btn.addEventListener("click", function () {
      wrap.classList.add("is-playing");
      if (video) { video.controls = true; video.play().catch(function () {}); }
      if (iframe && iframe.dataset.src) { iframe.src = iframe.dataset.src; }
      once("vstart:" + vid, function () { track("video_start", { component_id: cid, params: { video_id: vid } }); });
      interagir("video_start");
    });
    if (video) video.addEventListener("timeupdate", function () {
      if (video.duration && video.currentTime / video.duration >= 0.5) {
        once("v50:" + vid, function () { track("video_progress_50", { component_id: cid, params: { video_id: vid } }); });
      }
    });
  });

  /* ── FAQ ────────────────────────────────────────────────────── */
  doc.querySelectorAll(".ec-faq details").forEach(function (d) {
    d.addEventListener("toggle", function () {
      if (!d.open) return;
      var section = d.closest("[data-ec-component]");
      interagir("faq_open");
    });
  });

  /* ── Avis : interactions du bloc Reviews ────────────────────── */
  var reviews = doc.querySelector('[data-ec-component="C12"]');
  if (reviews) reviews.addEventListener("click", function (ev) {
    var hit = ev.target.closest && ev.target.closest(".fluviqa-avis, .fluviqa-resume, [data-ec-review]");
    if (!hit) return;
    track("review_interaction", { component_id: "C12", params: { review_id: hit.getAttribute("data-review-id") || "" } });
    interagir("review_interaction");
  });

  /* ── Profondeur de défilement ───────────────────────────────── */
  var ticking = false;
  window.addEventListener("scroll", function () {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var h = doc.documentElement, total = h.scrollHeight - h.clientHeight;
      if (total <= 0) return;
      var part = h.scrollTop / total;
      if (part > eng.defilement) eng.defilement = part;
      if (part >= CRITERES.defilement) qualifier("defilement");
      if (part >= 0.75) once("scroll75", function () { track("scroll_75", {}); });
    });
  }, { passive: true });

  /* ── CTA collant mobile ─────────────────────────────────────────
     Apparaît quand le hero a quitté l'écran (< 10 % visible), disparaît
     quand le CTA principal de commande est visible — règle du playbook.
  */
  var sticky = doc.querySelector("[data-ec-sticky]");
  var hero = doc.querySelector('[data-ec-component="C02"]');
  var checkout = doc.querySelector('[data-ec-component="C09"]');
  if (sticky && hero && "IntersectionObserver" in window) {
    var heroGone = false, checkoutSeen = false;
    function refresh() { var on = heroGone && !checkoutSeen; sticky.classList.toggle("is-shown", on); sticky.setAttribute("aria-hidden", on ? "false" : "true"); sticky.inert = !on; }
    new IntersectionObserver(function (e) { heroGone = e[0].intersectionRatio < 0.1; refresh(); }, { threshold: [0, 0.1, 0.5] }).observe(hero);
    if (checkout) new IntersectionObserver(function (e) { checkoutSeen = e[0].isIntersecting; refresh(); }, { threshold: 0.2 }).observe(checkout);
  }

  /* ── Ancrages doux ────────────────────────────────────────────── */
  doc.addEventListener("click", function (ev) {
    var a = ev.target.closest && ev.target.closest('a[href^="#"]');
    if (!a || reduced) return;
    var target = doc.querySelector(a.getAttribute("href"));
    if (!target) return;
    ev.preventDefault();
    target.scrollIntoView({ behavior: "smooth", block: "start" });
    if (!target.hasAttribute("tabindex")) target.setAttribute("tabindex", "-1");
    target.focus({ preventScroll: true });
  });

  /* ── Date d'arrivée estimée ────────────────────────────────────
     La seule urgence légitime dont on dispose : une date vraie, qui
     répond à une question que le visiteur se pose de toute façon.
     Calculée ici et non en Liquid, parce que Shopify met les pages en
     cache : une date rendue côté serveur finirait par être périmée.
     Le bloc reste masqué si le calcul échoue — rien vaut mieux qu'une
     promesse fausse. */
  (function () {
    var bloc = doc.querySelector("[data-ec-livraison]");
    if (!bloc) return;
    var mn = bloc.querySelector("[data-ec-livraison-min]");
    var mx = bloc.querySelector("[data-ec-livraison-max]");
    if (!mn || !mx) return;
    try {
      var fmt = function (jours) {
        var d = new Date();
        d.setDate(d.getDate() + jours);
        return d.toLocaleDateString("fr-FR", { day: "numeric", month: "long" });
      };
      mn.textContent = fmt(7);
      mx.textContent = fmt(10);
      bloc.hidden = false;
    } catch (e) { /* masqué : on n'annonce pas de date qu'on ne sait pas calculer */ }
  })();

})();
